(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-mozaic"] && !Shopify.designMode) return;
  try {
    
  class HeroMozaic extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.hero-mozaic__slider');
      this.dots = this.querySelectorAll('.hero-mozaic__dot');
      this.slides = this.querySelectorAll('.hero-mozaic__slide');
      this.currentSlide = 0;

      this.init();
    }

    init() {
      // Slider functionality
      if (this.slider && this.dots.length > 0) {
        this.slider.addEventListener('scroll', this.handleScroll.bind(this));

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goToSlide(index));
        });
      }
    }

    handleScroll() {
      const scrollLeft = this.slider.scrollLeft;
      const slideWidth = this.slider.offsetWidth;
      const newSlide = Math.round(scrollLeft / slideWidth);

      if (newSlide !== this.currentSlide) {
        this.currentSlide = newSlide;
        this.updateDots();
      }
    }

    goToSlide(index) {
      const slideWidth = this.slider.offsetWidth;
      this.slider.scrollTo({
        left: slideWidth * index,
        behavior: 'smooth'
      });
    }

    updateDots() {
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('hero-mozaic__dot--active', index === this.currentSlide);
      });
    }
  }

  if (!customElements.get('hero-mozaic')) {
    customElements.define('hero-mozaic', HeroMozaic);
  }

  } catch(e) { console.error(e); }
})();
})();
